/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { Accounts_accounts__objects_commissionRates_fees } from "./Accounts";
import { Companies_companies_objects_registeredCountries } from "./Companies";
import { CompanySourceEntity } from "./CompaniesOverview";

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountsSortKeys {
  name = "name",
}

export enum CompanieSortKeys {
  countryCode = "countryCode",
  createdAt = "createdAt",
  name = "name",
}

export enum PartialExemptionType {
  Company = "Company",
  Team = "Team",
}

export enum SortType {
  asc = "asc",
  desc = "desc",
}

export enum CompanyProducts {
  vat = "vat",
  apai = "apai",
}

/**
 * this enum is used to check if the user has access to the resource
 * (authorization) and also responsible of the user׳s scope (internal users see all
 * data and external user see only their data)
 */
export enum UserRole {
  Admin = "Admin",
  Analyst = "Analyst",
  System = "System",
  User = "User",
}

export enum UserSortKeys {
  createdAt = "createdAt",
  email = "email",
  firstName = "firstName",
  lastName = "lastName",
  role = "role",
  updatedAt = "updatedAt",
}

export enum UserStatus {
  Active = "Active",
  Invited = "Invited",
}

export enum VatPortalType {
  HMRC = "HMRC",
}

export enum CommissionFieldType {
  ExpenditureType = "ExpenditureType",
  Image2Line = "Image2Line",
  LowValue = "LowValue",
  Physical = "Physical",
  Reissue = "Reissue",
}

export enum ComissionLogicType {
  Accumulate = "Accumulate",
  Max = "Max",
}

export enum ExpenditureType {
  AP = "AP",
  TnE = "TnE",
}

export interface AccountsFilter {
  ids: any[];
  names: string[];
  bdrUserIds: number[];
  csmUserIds: number[];
  name: string | null;
}

export interface AccountsList {
  skip?: number | null;
  limit?: number | null;
  order?: AccountsSort | null;
}

export interface AccountsSort {
  key: AccountsSortKeys;
  type: SortType;
}

export interface AddressInput {
  addressType?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  region?: string | null;
  postalCode?: string | null;
  countryCode?: any | null;
}

export interface BankDetailsInput {
  name?: string | null;
  accountNumber?: string | null;
  ibanNumber?: string | null;
  address?: string | null;
  bankNumber?: string | null;
  sortCode?: string | null;
}

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export interface CompaniesAttachmentFilterInput {
  ids?: (string | null)[] | null;
}

export interface CompaniesFilter {
  ids: any[];
  names: string[];
  accountIds: any[];
  countryCodes: any[];
  partialExemptionType?: PartialExemptionType | null;
  enabledProducts?: CompanyProducts[];
}

export interface CompaniesList {
  skip?: number | null;
  limit?: number | null;
  order?: CompaniesSort | null;
}

export interface CompaniesSort {
  key: CompanieSortKeys;
  type: SortType;
}

export interface CompanyAttachmentInput {
  file: any;
}

export interface ContactInput {
  name?: string | null;
  email?: any | null;
  phone?: string | null;
  mobile?: string | null;
  linkedIn?: string | null;
}

export interface CreateAccountInput {
  name: string;
  bdrUserId?: number | null;
  csmUserId?: number | null;
}

export interface CreateCompanyInput {
  name: string;
  accountName: string;
  countryCode: any;
  contacts?: ContactInput[] | null;
  vatNumber: string;
  address?: AddressInput | null;
  partialExemptionType?: PartialExemptionType | null;
  bankDetails?: BankDetailsInput | null;
  vatPortals?: VatPortalInput[] | null;
  partialExemption: boolean;
  registeredCountries: Companies_companies_objects_registeredCountries[] | null;
  enabledProducts: CompanyProducts[];
  companySourceEntity: CompanySourceEntity;
  nameVariations?: string[] | null;
  addressVariations?: AddressInput[] | null;
}

export interface CommissionRatesInput {
  accountId: string;
  feeModal: Accounts_accounts__objects_commissionRates_fees[];
  logicType: ComissionLogicType;
}

export interface DeleteCompanyAttachmentInput {
  companyId: string;
  id: string;
}

export interface InviteUserInput {
  email: string;
  role: UserRole;
  companiesIds: any[];
}

export interface ResendInvitationInput {
  userId: number;
}

export interface UpdateCompanyInput {
  id: any;
  countryCode: any;
  name: string;
  accountName: string;
  contacts?: ContactInput[] | null;
  address?: AddressInput | null;
  partialExemptionType?: PartialExemptionType | null;
  partialExemption: boolean;
  bankDetails?: BankDetailsInput | null;
  vatPortals?: VatPortalInput[] | null;
  vatNumber: string;
  registeredCountries: Companies_companies_objects_registeredCountries[] | null;
  enabledProducts: CompanyProducts[];
  companySourceEntity: CompanySourceEntity;
  nameVariations?: string[] | null;
  addressVariations?: AddressInput[] | null;
}

export interface UpdateUserInput {
  id: number;
  firstName?: string | null;
  lastName?: string | null;
  role?: UserRole | null;
  companyIds: any[];
}

export interface UploadMediaCompanyDocumentsInput {
  files: (CompanyAttachmentInput | null)[];
  companyId: string;
}

export interface UpsertCompanyAgreementInput {
  companyId: string;
  id?: string | null;
  attachments: (string | null)[];
}

export interface UpsertCompanyPowerOfAttorneyInput {
  companyId: string;
  id?: string | null;
  countryCode: string;
  attachments: (string | null)[];
}

export interface UpsertCompanyTaxCertificateInput {
  companyId: string;
  id?: string | null;
  startDate: any;
  endDate: any;
  attachments: (string | null)[];
}

export interface UserSort {
  key: UserSortKeys;
  type: SortType;
}

export interface UsersFilter {
  ids: number[];
  companiesIds: any[];
  firstNames: string[];
  lastNames: string[];
  emails: any[];
  roles: UserRole[];
  status: UserStatus[];
}

export interface UsersList {
  skip?: number | null;
  limit?: number | null;
  order?: UserSort | null;
}

export interface VatPortalInput {
  type?: VatPortalType | null;
  id: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
